import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyle = makeStyles((theme) => ({
    checkBox: {
        width:"15px",
        height:"15px",
        marginRight:"5px",
        position:"relative",
        top:"2px",
        border: "2px solid #BB0D66",
        borderColor:"#BB0D66",
        '&:checked': {
            border: "1px solid red",
            color:"#BB0D66",
        },
    },

label: {
        fontSize:"16px",
    }
}))

const CheckboxField = ({ field, form, label, ...rest }) => {
    const classes = useStyle();
    const { name, value: formikValue } = field;
    const { setFieldValue } = form;

    const handleChange = event => {
        const values = formikValue || [];
        const index = values.indexOf(rest.value);
        if (index === -1) {
            values.push(rest.value);
        } else {
            values.splice(index, 1);
        }
        setFieldValue(name, values);
    };

    return (
        <label className={classes.label}>
            <input
                className={classes.checkBox}
                type="checkbox"
                onChange={handleChange}
                checked={formikValue.indexOf(rest.value) !== -1}
            />
            {label}
        </label>
    );
};

export default CheckboxField;